module.exports = __webpack_public_path__ + "img/product-m-qrcode.c4db2854.png";